import joi from 'joi-browser';
import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form } from 'antd';
import Layout from '../Layout';
import EditForm from '../../components/EditForm';
import { getById, save, resetState, resetSuccessSave } from '../../modules/admins';

class AdminForm extends EditForm {
  validationSchema = joi.object({
    id: joi.number().default(null),
    first_name: joi.string().trim().required(),
    last_name: joi.string().trim().required(),
    email: joi.string().email().trim().required(),
    phone_number: joi.string().trim().required(),
    password: joi.string().min(6).when('id', { is: null, then: joi.required() }),
    confirm: joi.string()
      .valid(joi.ref('password'))
      .when('id', { is: null, then: joi.required() })
      .strip(),
  });

  static getDerivedStateFromProps(props) {
    const { data } = props;

    if (data && data.id) {
      return { data };
    }

    return null;
  }

  render() {
    const { successSave, error } = this.props;
    const layout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };

    return (
      <Layout>
        <Form onSubmit={this.onSubmit}>
          {this.renderFormActions('Save')}
          <Row type="flex">
            <Col span={24}>
              <Row type="flex" justify="center">
                <Col offset={6} xs={18}>
                  {error && this.renderErrorAlert(error)}
                  {successSave && this.renderSuccessAlert('Admin has been successfully saved.')}
                </Col>
              </Row>
              <div className="container-sm">
                {this.renderInput('first_name', true, 'First Name', null, null, null, layout)}
                {this.renderInput('last_name', true, 'Last Name', null, null, null, layout)}
                {this.renderInput('email', true, 'Email', null, null, null, layout)}
                {this.renderInput('phone_number', true, 'Phone Number', null, null, null, layout)}
                {this.renderInput('password',
                  !this.state.data.id,
                  'Password',
                  null,
                  'password',
                  null,
                  layout)}
                {this.renderInput('confirm',
                  !this.state.data.id,
                  'Confirm Password',
                  null,
                  'password',
                  null,
                  layout)}
              </div>
            </Col>
          </Row>
        </Form>
      </Layout>
    );
  }
}

export default connect(state => state.admins, {
  getById,
  onSubmit: save,
  resetState,
  resetSuccessSave,
})(AdminForm);



// WEBPACK FOOTER //
// ./src/containers/Admins/AdminForm.js